import { Box } from '@mui/material';
import {
  ResponseDataHandle,
  ListPlaceholder,
  ErrorList,
  EmptyData,
} from '@/components/common';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';
import { ColumnDefinitionType } from '@/components/common/Table/table.utils';
import React from 'react';
import { Entry } from '@/@types/entries';
import { EntriesTable } from '../EntriesTable';

type TEntriesData = {
  entries: Entry[];
  totalCount: number;
};

interface IEntriesListProps {
  columns: ColumnDefinitionType<Entry>[];
  isLoading: boolean;
  isError: boolean;
  data: TEntriesData | undefined;
  sort?: 'desc' | 'asc';
  sortBy?: keyof Entry;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
  selected?: string[];
  // eslint-disable-next-line no-unused-vars
  onSelectAll?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  // eslint-disable-next-line no-unused-vars
  onItemClick?: (event: React.MouseEvent<unknown>, id: string) => void;
}

export function EntriesList({
  columns,
  isLoading,
  isError,
  data,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
  selected,
  onSelectAll,
  onItemClick,
}: IEntriesListProps) {
  return (
    <ResponseDataHandle
      isLoading={isLoading}
      loadingComponent={
        <ListPlaceholder
          headers={[
            'Data',
            'Fornecedor',
            'Colaborador',
            'Operação',
            'Total',
            'Status',
            'Criado em',
            'Ações',
          ]}
        />
      }
      isError={isError}
      errorComponent={
        <Box py={10}>
          <ErrorList text="Falha ao obter os dados das compras." />
        </Box>
      }
      totalItems={data?.totalCount}
      emptyComponent={
        <Box py={10}>
          <EmptyData />
        </Box>
      }
    >
      <EntriesTable
        columns={columns}
        data={data?.entries || []}
        sort={sort}
        sortBy={sortBy}
        onSort={onSort}
        actions={actions}
        pagination={pagination}
        selected={selected}
        selectedKey="id"
        onSelectAll={onSelectAll}
        onItemClick={onItemClick}
      />
    </ResponseDataHandle>
  );
}
